import React from "react";

function Footer() {
  return (
    <div>
      <footer className="bg-background text-foreground font-medium font-jakarta text-sm md:text-base px-6 md:px-[75px] pb-10 pt-24">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-0 mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold tracking-tight">
              <a href="index.html">
                Sound<span className="text-brand">.</span>
              </a>
            </h2>
          </div>
          <div>
            <ul className="space-y-2">
              <li>
                <a className="hover:text-brand transition" href="#services">
                  Services
                </a>
              </li>
              <li>
                <a className="hover:text-brand transition" href="#about">
                  About Us
                </a>
              </li>
              <li>
                <a className="hover:text-brand transition" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <ul className="space-y-2">
              <li>
                <a
                  className="hover:text-brand transition"
                  href="https://www.linkedin.com/company/sound-commerce"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-xs text-muted-foreground text-center">
          <p>&copy; 2025 Sound Commerce. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
